import { createContext, useContext } from "react";

import { MarketingCampaignFormModelContext } from "../../_shared/context";

import type { MarketingCampaignFormModelContextType } from "../../_shared/context/context";

export type MarketingExistingCampaignFormModelContextType = {
	onUpdate: () => void;
	onPublish: () => void;
} & MarketingCampaignFormModelContextType;

export const MarketingExistingCampaignFormModelContext =
	createContext<MarketingExistingCampaignFormModelContextType | null>(null);

export const MarketingExistingCampaignFormModelContextProvider = ({
	value,
	children,
}: {
	value: MarketingExistingCampaignFormModelContextType;
	children: React.ReactNode;
}) => {
	return (
		<MarketingExistingCampaignFormModelContext.Provider value={value}>
			<MarketingCampaignFormModelContext.Provider value={value}>
				{children}
			</MarketingCampaignFormModelContext.Provider>
		</MarketingExistingCampaignFormModelContext.Provider>
	);
};

export const useMarketingExistingCampaignFormModelContext = () => {
	const context = useContext(MarketingExistingCampaignFormModelContext);

	if (!context) {
		throw new Error(
			"useMarketingExistingCampaignFormModelContext must be used within a MarketingExistingCampaignFormModelContextProvider",
		);
	}

	return {
		onUpdate: context.onUpdate,
		onPublish: context.onPublish,
	};
};
